(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["shc-accessibility-footer"] && !Shopify.designMode) return;
  try {
    (() => {
 const slot=document.querySelector('[data-shc-accessibility-slot]');
 if(!slot)return;
 const dock=()=>{
  const icon=document.getElementById('accessease-icon');
  const host=document.getElementById('accessease-icon-element');
  if(!icon||!host)return false;
  if(host.parentElement!==slot)slot.append(host);
  if(!icon.querySelector('.shc-accessibility-label')){
   const label=document.createElement('span');label.className='shc-accessibility-label';label.textContent=slot.dataset.label;icon.append(label);
  }
  return true;
 };
 if(dock())return;
 const observer=new MutationObserver(()=>{if(dock())observer.disconnect();});
 observer.observe(document.body,{childList:true,subtree:true});
 window.setTimeout(()=>observer.disconnect(),20000);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["shc-collection-shop"] && !Shopify.designMode) return;
  try {
    (() => {
 const section=document.querySelector('.shc3-collection-page, .shc3-search-page');
 if(!section)return;
 const quick=section.querySelector('[data-shc-quick-sheet]');
 const filters=section.querySelector('[data-shc-filter-sheet]');
 const body=quick.querySelector('[data-shc-quick-body]');
 const status=quick.querySelector('[data-shc-quick-status]');
 const fallback=quick.querySelector('[data-shc-quick-fallback]');
 const cartLink=quick.querySelector('[data-shc-quick-cart]');
 let opener=null,controller=null,adding=false;
 const preservePreview=url=>{
  const current=new URL(location.href);
  for(const key of ['preview_theme_id','_fd','pb'])if(current.searchParams.has(key))url.searchParams.set(key,current.searchParams.get(key));
  return url;
 };
 const loadProduct=async (href,retain)=>{
  controller?.abort();controller=new AbortController();const active=controller;
  status.textContent=quick.dataset.loading;fallback.hidden=true;cartLink.hidden=true;body.inert=true;
  if(!retain)body.replaceChildren();
  const url=preservePreview(new URL(href,location.origin));
  fallback.href=url.href;url.searchParams.set('view','shc-quickshop');
  try{
   const response=await fetch(url,{credentials:'same-origin',signal:active.signal});
   if(!response.ok)throw new Error('load');
   const html=new DOMParser().parseFromString(await response.text(),'text/html');
   const product=html.querySelector('[data-shc-quick-product]');
   if(!product)throw new Error('load');
   if(controller!==active||!quick.open)return;
   body.replaceChildren(document.importNode(product,true));status.textContent='';
   if(retain)body.querySelector('[data-shc-quick-color][aria-pressed=true]')?.focus({preventScroll:true});
  }catch(error){if(error.name!=='AbortError'){status.textContent=quick.dataset.loadError;fallback.hidden=false;}}
  finally{if(controller===active)body.inert=false;}
 };
 for(const dialog of [quick,filters].filter(Boolean)){
  dialog.addEventListener('click',event=>{if(event.target===dialog){const rect=dialog.getBoundingClientRect();if(event.clientX<rect.left||event.clientX>rect.right||event.clientY<rect.top||event.clientY>rect.bottom)dialog.close();}});
 }
 quick.addEventListener('close',()=>{controller?.abort();});
 section.addEventListener('click',event=>{
  const close=event.target.closest('[data-shc-sheet-close]');
  if(close){close.closest('dialog').close();return;}
  const color=event.target.closest('[data-shc-card-color]');
  if(color){
   const card=color.closest('.c-product');
   card.querySelectorAll('[data-shc-card-color]').forEach(button=>button.setAttribute('aria-pressed',String(button===color)));
   const image=card.querySelector('.c-product-image img');
   if(image&&color.dataset.image){image.src=color.dataset.image;image.removeAttribute('srcset');}
   card.querySelectorAll('.c-product-image,.c-product-name,[data-shc-quick-open]').forEach(link=>link.href=color.dataset.url);
   return;
  }
  const more=event.target.closest('[data-shc-more-colors]');
  if(more){more.closest('.shc-card-swatches').querySelectorAll('[data-shc-extra-color]').forEach(button=>button.hidden=false);more.hidden=true;return;}
  const open=event.target.closest('[data-shc-quick-open]');
  if(open){event.preventDefault();opener=open;quick.showModal();loadProduct(open.href,false);return;}
  const quickColor=event.target.closest('[data-shc-quick-color]');
  if(quickColor){loadProduct(quickColor.dataset.shcQuickColor,true);return;}
  const filter=event.target.closest('[data-shc-filter-open]');
  if(filter&&filters){
   filters.querySelector('form').reset();
   filters.showModal();filters.querySelector('.shc-sheet-body').scrollTop=0;return;
  }
 });
 filters?.addEventListener('change',event=>{if(event.target.matches('[data-shc-sort-choice]'))event.target.form.requestSubmit();});
 filters?.querySelector('form')?.addEventListener('submit',event=>{
  event.preventDefault();
  const url=preservePreview(new URL(event.target.action,location.origin));
  for(const [key,value] of new FormData(event.target))if(String(value).trim())url.searchParams.append(key,String(value));
  const first=new URL(location.href).searchParams.get('first');
  if(first&&!url.searchParams.has('first'))url.searchParams.set('first',first);
  location.assign(url.href);
 });
 quick.addEventListener('submit',async event=>{
  const form=event.target.closest('[data-shc-quick-form]');
  if(!form)return;
  event.preventDefault();if(adding||!event.submitter?.value)return;
  adding=true;body.inert=true;status.textContent=quick.dataset.adding;
  const drawer=document.querySelector('cart-drawer');
  const root=window.Shopify?.routes?.root||'/';
  const payload={items:[{id:Number(event.submitter.value),quantity:1}]};
  if(drawer?.getSectionsToRender){payload.sections=drawer.getSectionsToRender().map(item=>item.id);payload.sections_url=location.pathname;drawer.setActiveElement(opener);}
  try{
   const response=await fetch(root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify(payload)});
   const result=await response.json();
   if(!response.ok)throw new Error(result.description||result.message||quick.dataset.cartError);
   body.replaceChildren();status.textContent=quick.dataset.added;cartLink.hidden=false;
   if(drawer){
    try{
     if(!result.sections?.['cart-drawer']){
      const url=new URL(root,location.origin);url.searchParams.set('sections',drawer.getSectionsToRender().map(item=>item.id).join(','));
      const refreshed=await fetch(url,{headers:{Accept:'application/json'}});
      if(!refreshed.ok)throw new Error('drawer');result.sections=await refreshed.json();
     }
     if(!result.sections?.['cart-drawer'])throw new Error('drawer');
     quick.close();drawer.classList.remove('is-empty');drawer.renderContents(result);
    }catch{if(!quick.open)quick.showModal();cartLink.focus();}
   }
   try{const cart=await fetch(root+'cart.js').then(response=>response.json());document.querySelectorAll('[data-shc3-cart-count]').forEach(el=>el.textContent=cart.item_count);}catch{}
   document.dispatchEvent(new CustomEvent('shc3:cart-added',{detail:result}));
  }catch(error){status.textContent=error.message||quick.dataset.cartError;}
  finally{adding=false;body.inert=false;}
 });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["shc-concept-fit-carousel"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('shc-fit-carousel')){
  customElements.define('shc-fit-carousel',class extends HTMLElement{
    connectedCallback(){
      if(this.ready)return;
      this.ready=true;
      this.track=this.querySelector('[data-fit-track]');
      this.slides=Array.from(this.querySelectorAll('[data-fit-slide]'));
      this.picks=Array.from(this.querySelectorAll('[data-fit-index]'));
      this.previous=this.querySelector('[data-fit-prev]');
      this.next=this.querySelector('[data-fit-next]');
      this.index=0;
      this.querySelector('[data-fit-controls]').hidden=false;
      this.previous.addEventListener('click',()=>this.go(this.index-1));
      this.next.addEventListener('click',()=>this.go(this.index+1));
      this.picks.forEach(button=>button.addEventListener('click',()=>this.go(Number(button.dataset.fitIndex))));
      this.track.addEventListener('scroll',()=>{
        cancelAnimationFrame(this.scrollFrame);
        this.scrollFrame=requestAnimationFrame(()=>this.sync());
      },{passive:true});
      this.track.addEventListener('keydown',event=>{
        if(event.key==='ArrowRight'||event.key==='ArrowLeft'){
          event.preventDefault();
          this.go(this.index+(event.key==='ArrowRight'?1:-1));
        }
      });
      this.sync();
    }
    position(index){return this.slides[index].offsetLeft-this.slides[0].offsetLeft;}
    go(index){
      this.index=Math.max(0,Math.min(this.slides.length-1,index));
      const left=Math.min(this.position(this.index),this.track.scrollWidth-this.track.clientWidth);
      this.track.scrollTo({left,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
      this.controls();
    }
    sync(){
      let nearest=0;
      this.slides.forEach((slide,index)=>{
        if(Math.abs(this.position(index)-this.track.scrollLeft)<Math.abs(this.position(nearest)-this.track.scrollLeft))nearest=index;
      });
      this.index=nearest;
      this.controls();
    }
    controls(){
      this.previous.disabled=this.index===0;
      this.next.disabled=this.index===this.slides.length-1;
      this.picks.forEach((button,index)=>button.setAttribute('aria-pressed',String(index===this.index)));
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["shc-concept-recommendations"] && !Shopify.designMode) return;
  try {
    (() => {
  const connected = new WeakSet();
  const connect = (root = document) => {
    root.querySelectorAll('.p-gallery-recommendations').forEach((section) => {
      if (connected.has(section)) return;
      const rail = section.querySelector('.p-gallery-products');
      const previous = section.querySelector('[data-shc3-tees][data-direction="-1"]');
      const next = section.querySelector('[data-shc3-tees][data-direction="1"]');
      if (!rail || !previous || !next) return;
      connected.add(section);
      let target = null;
      let settleTimer;
      const maximum = () => Math.max(0, rail.scrollWidth - rail.clientWidth);
      const clamp = (value) => Math.min(maximum(), Math.max(0, value));
      const update = () => {
        const position = clamp(target === null ? rail.scrollLeft : target);
        previous.disabled = position <= 2;
        next.disabled = position >= maximum() - 2;
      };
      const settle = () => {
        clearTimeout(settleTimer);
        target = null;
        update();
      };
      const move = (direction) => {
        const max = maximum();
        const position = clamp(target === null ? rail.scrollLeft : target);
        if ((direction < 0 && position <= 2) || (direction > 0 && position >= max - 2)) {
          update();
          return;
        }
        const first = rail.children[0];
        const second = rail.children[1];
        const step = first && second
          ? Math.abs(second.getBoundingClientRect().left - first.getBoundingClientRect().left)
          : rail.clientWidth;
        const count = Math.max(1, Math.floor(rail.clientWidth / Math.max(1, step)));
        target = clamp(position + direction * step * count);
        update();
        clearTimeout(settleTimer);
        settleTimer = setTimeout(settle, 800);
        rail.scrollTo({
          left: target,
          behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'
        });
      };
      previous.addEventListener('click', () => move(-1));
      next.addEventListener('click', () => move(1));
      rail.addEventListener('scroll', () => {
        update();
        clearTimeout(settleTimer);
        settleTimer = setTimeout(settle, 150);
      }, { passive: true });
      rail.addEventListener('scrollend', settle);
      rail.addEventListener('pointerdown', settle, { passive: true });
      rail.addEventListener('touchstart', settle, { passive: true });
      rail.addEventListener('wheel', settle, { passive: true });
      rail.addEventListener('keydown', settle);
      const resize = new ResizeObserver(() => {
        settle();
        const position = clamp(rail.scrollLeft);
        if (Math.abs(position - rail.scrollLeft) > 2) rail.scrollTo({ left: position, behavior: 'instant' });
      });
      resize.observe(rail);
      Array.from(rail.children).forEach((card) => resize.observe(card));
      update();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => connect(), { once: true });
  else connect();
  document.addEventListener('shopify:section:load', (event) => connect(event.target));
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["shc3-fit-finder"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('shc3-fit-finder')) {
  customElements.define('shc3-fit-finder', class extends HTMLElement {
    static estimate(data, family, height, weight, preference, usual = '') {
      if (!Number.isFinite(height) || !Number.isFinite(weight) || height < 48 || height > 94 || weight < 60 || weight > 600) return null;
      const reports = data.reports.filter(r => r.family === family && Math.abs(r.height - height) <= 1 && Math.abs(r.weight - weight) <= 5);
      const club = reports.filter(r => r.club);
      const ranges = data.ranges.filter(r => r.family === family && height >= r.height[0] && (r.height[1] === null || height <= r.height[1]) && weight >= r.weight[0] && weight <= r.weight[1]);
      const sizes = club.length ? club.flatMap(r => r.sizes) : reports.length ? reports.flatMap(r => r.sizes) : ranges.map(r => r.size);
      const candidates = [...new Set(sizes)].sort((a, b) => data.order.indexOf(a) - data.order.indexOf(b));
      if (candidates.length && data.order.indexOf(candidates[candidates.length - 1]) - data.order.indexOf(candidates[0]) > 1) candidates.length = 0;
      const fromUsual = candidates.length === 0 && data.order.includes(usual);
      if (fromUsual) candidates.push(usual);
      if (!candidates.length) return { needsUsual: true };
      const base = preference === 'closer' ? candidates[0] : candidates[candidates.length - 1];
      const index = data.order.indexOf(base) + (preference === 'oversized' ? 1 : 0);
      return { size: data.order[index] || null, candidates, fromUsual, report: (club[0] || reports[0])?.copy || '', oversized: preference === 'oversized' };
    }
    connectedCallback() {
      if (this.listeners) return;
      this.listeners = new AbortController();
      const listen = (el, event, handler) => el?.addEventListener(event, handler, { signal: this.listeners.signal });
      const root = this.closest('shc3-product');
      const dialog = this.querySelector('dialog');
      const form = this.querySelector('form');
      const feet = this.querySelector('[data-fit-feet]'), inches = this.querySelector('[data-fit-inches]');
      const cm = this.querySelector('[data-fit-cm]'), weight = this.querySelector('[data-fit-weight]');
      const error = this.querySelector('.shc3-fit-error'), result = this.querySelector('.shc3-fit-result');
      const evidence = JSON.parse(this.querySelector('[data-fit-evidence]').textContent);
      const copy = Object.fromEntries(Array.from(this.querySelectorAll('[data-copy-key]'), el => [el.dataset.copyKey, el.textContent]));
      const fallback = this.querySelector('.shc3-fit-fallback');
      const apply = this.querySelector('[data-fit-apply]');
      let unit = 'us', preserved = null, usual = '', chosenSize = '';
      const say = (key, replacements = {}) => Object.entries(replacements).reduce((text, [name, value]) => text.replaceAll('[' + name + ']', value), copy[key] || '');
      const sizeInput = size => Array.from(root.querySelectorAll('[data-option-name="size"] input[data-option-value-id]')).find(input => input.value.trim().toUpperCase().replace('XXXL', '3XL').replace('XXL', '2XL') === size);
      const renderResult = () => {
        const v = values();
        const preference = form.querySelector('[name="fit-preference"]:checked')?.value || 'relaxed';
        const estimate = this.constructor.estimate(evidence, this.dataset.garmentFamily, v.height, v.weight, preference, usual);
        if (!estimate || estimate.needsUsual) { fallback.hidden = false; fallback.scrollIntoView({ block: 'nearest' }); return; }
        fallback.hidden = !estimate.fromUsual;
        chosenSize = estimate.size;
        result.querySelector('[data-fit-result-label]').textContent = say(estimate.fromUsual ? 'usual_result' : 'estimated');
        result.querySelector('[data-fit-result-size]').textContent = chosenSize || say('no_size');
        const range = estimate.candidates.join(' / ');
        result.querySelector('[data-fit-result-copy]').textContent = say(estimate.fromUsual ? 'usual_copy' : estimate.oversized ? 'oversize_result' : estimate.candidates.length > 1 ? 'range' : 'single', { range, size: chosenSize || '' });
        result.querySelector('[data-fit-report]').textContent = say(estimate.report);
        const input = chosenSize && sizeInput(chosenSize);
        const unavailable = input?.closest('label').querySelector('.shc3-unavailable');
        result.querySelector('[data-fit-stock]').textContent = !input ? say('not_offered') : unavailable ? say('unavailable') : '';
        apply.disabled = !input || Boolean(unavailable);
        apply.hidden = !chosenSize;
        apply.textContent = say('apply', { size: chosenSize || '' });
        result.hidden = false;
        result.scrollIntoView({ block: 'nearest' });
      };
      const number = input => input.value.trim() === '' ? null : Number(input.value);
      const values = () => {
        if (preserved) return preserved;
        const f = number(feet), i = number(inches), c = number(cm), w = number(weight);
        const imperial = f === null || i === null ? null : Number.isInteger(f) && Number.isInteger(i) && f >= 4 && f <= 7 && i >= 0 && i <= 11 ? f * 12 + i : NaN;
        return { height: unit === 'us' ? imperial : c === null ? null : c / 2.54, weight: w === null ? null : w * (unit === 'us' ? 1 : 2.20462262185) };
      };
      const clearResult = () => { error.textContent = ''; result.hidden = true; fallback.hidden = true; chosenSize = ''; };
      listen(root, 'click', event => {
        const opener = event.target.closest('[data-shc3-fit-open]');
        if (opener && opener.getAttribute('aria-controls') === dialog.id) { clearResult(); dialog.showModal(); }
      });
      listen(dialog, 'click', event => {
        if (event.target.closest('[data-fit-suggest]')) { form.scrollIntoView({ block: 'nearest', behavior: 'smooth' }); (unit === 'us' ? feet : cm).focus({ preventScroll: true }); }
        if (event.target === dialog || event.target.closest('[data-fit-close]')) dialog.close();
        const usualButton = event.target.closest('[data-fit-usual]');
        if (usualButton) {
          usual = usualButton.dataset.fitUsual;
          this.querySelectorAll('[data-fit-usual]').forEach(b => b.setAttribute('aria-pressed', String(b === usualButton)));
          renderResult();
        }
        if (event.target.closest('[data-fit-apply]') && !apply.disabled) {
          const input = sizeInput(chosenSize);
          if (input) { dialog.close(); input.checked = true; input.dispatchEvent(new Event('change', { bubbles: true })); input.focus({ preventScroll: true }); }
        }
        const button = event.target.closest('[data-fit-unit]');
        if (!button || unit === button.dataset.fitUnit) return;
        const v = values();
        preserved = { height: Number.isFinite(v.height) ? v.height : null, weight: Number.isFinite(v.weight) ? v.weight : null };
        unit = button.dataset.fitUnit;
        const metric = unit === 'metric';
        this.querySelector('[data-fit-imperial]').hidden = metric;
        this.querySelector('[data-fit-metric]').hidden = !metric;
        feet.disabled = inches.disabled = metric; cm.disabled = !metric;
        const total = preserved.height === null ? null : Math.round(preserved.height);
        feet.value = total === null ? '' : String(Math.floor(total / 12));
        inches.value = total === null ? '' : String(total % 12);
        cm.value = preserved.height === null ? '' : String(Number((preserved.height * 2.54).toFixed(1)));
        weight.value = preserved.weight === null ? '' : String(Number((preserved.weight / (metric ? 2.20462262185 : 1)).toFixed(1)));
        weight.min = metric ? '27' : '60'; weight.max = metric ? '272' : '600'; weight.placeholder = metric ? '70' : '155';
        this.querySelector('[data-fit-lb]').hidden = metric; this.querySelector('[data-fit-kg]').hidden = !metric;
        this.querySelectorAll('[data-fit-unit]').forEach(b => b.setAttribute('aria-pressed', String(b === button)));
        clearResult();
      });
      listen(form, 'input', event => { if (event.target.matches('input[type=number]')) { preserved = null; usual = ''; this.querySelectorAll('[data-fit-usual]').forEach(b => b.setAttribute('aria-pressed', 'false')); } clearResult(); });
      listen(form, 'submit', event => {
        event.preventDefault(); clearResult();
        const v = values();
        if (!Number.isFinite(v.height) || v.height < 48 || v.height > 94) { error.textContent = this.dataset.heightError; (unit === 'us' ? feet : cm).focus(); return; }
        if (!Number.isFinite(v.weight) || v.weight < 60 || v.weight > 600) { error.textContent = this.dataset.weightError; weight.focus(); return; }
        renderResult();
      });
    }
    disconnectedCallback() { this.listeners?.abort(); this.listeners = null; }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["shc3-foundation"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click',event=>{
 const review=event.target.closest('[data-shc3-review-dialog]');if(review){document.getElementById(review.dataset.shc3ReviewDialog)?.showModal();}
 const toggle=event.target.closest('[data-shc3-toggle]');
 if(toggle){const target=document.getElementById(toggle.dataset.shc3Toggle);if(target){target.hidden=!target.hidden;toggle.setAttribute('aria-expanded',String(!target.hidden));if(!target.hidden)target.querySelector('input')?.focus();}}
 const arrow=event.target.closest('[data-shc3-scroll]');
 if(arrow){const rail=document.getElementById(arrow.dataset.shc3Scroll);rail?.scrollBy({left:rail.clientWidth*.8*Number(arrow.dataset.direction),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});}
});
document.addEventListener('keydown',event=>{if(event.key==='Escape')document.querySelectorAll('[data-shc3-toggle][aria-expanded=true]').forEach(b=>b.click());});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["shc3-garment-measurements"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('shc3-garment-measurements')) {
  customElements.define('shc3-garment-measurements', class extends HTMLElement {
    connectedCallback() {
      if (this.events) return;
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      const dialog = this.querySelector('dialog');
      const opener = this.querySelector('[data-measure-open]');
      const parentDialog = this.closest('dialog');
      opener.addEventListener('click', () => { if (!dialog.open) dialog.showModal(); }, options);
      dialog.addEventListener('click', event => {
        event.stopPropagation();
        const rect = dialog.getBoundingClientRect();
        const outside = event.target === dialog && (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom);
        if (outside || event.target.closest('[data-measure-close]')) { dialog.close(); return; }
        const button = event.target.closest('[data-measure-unit]');
        if (!button) return;
        const metric = button.dataset.measureUnit === 'cm';
        this.querySelectorAll('[data-measure-unit]').forEach(el => el.setAttribute('aria-pressed', String(el === button)));
        this.querySelectorAll('[data-measure-inches]').forEach(el => { el.textContent = metric ? (Number(el.dataset.measureInches) * 2.54).toFixed(1) : el.dataset.measureInches; });
        this.querySelector('[data-measure-caption]').textContent = button.textContent;
      }, options);
      dialog.addEventListener('cancel', event => event.stopPropagation(), options);
      dialog.addEventListener('close', () => { if (parentDialog?.open && opener.isConnected) opener.focus({ preventScroll: true }); }, options);
      parentDialog?.addEventListener('close', () => { if (dialog.open) dialog.close(); }, options);
    }
    disconnectedCallback() { this.events?.abort(); this.events = null; }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["shc3-mobile-purchase"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('shc3-mobile-purchase')){
  customElements.define('shc3-mobile-purchase',class extends HTMLElement{
    connectedCallback(){
      queueMicrotask(()=>{if(this.isConnected)this.initialize();});
    }
    initialize(){
      if(this.ready)return;
      this.product=document.getElementById(this.dataset.productId);
      this.main=this.product?.querySelector('.p-main');
      if(!this.main)return;
      this.ready=true;
      this.media=matchMedia('(max-width:700px)');
      this.action=this.querySelector('[data-mobile-add]');
      this.onSync=()=>this.sync();
      this.onActivate=event=>{event.preventDefault();this.activate();};
      this.media.addEventListener('change',this.onSync);
      window.addEventListener('resize',this.onSync);
      window.visualViewport?.addEventListener('resize',this.onSync);
      this.product.addEventListener('change',this.onSync);
      this.action.addEventListener('click',this.onActivate);
      this.changes=new MutationObserver(this.onSync);
      this.changes.observe(this.main,{subtree:true,childList:true,characterData:true,attributes:true,attributeFilter:['disabled','checked','value']});
      if('IntersectionObserver' in window){
        this.intersection=new IntersectionObserver(this.onSync,{threshold:[0,1]});
      }else{
        this.onScroll=()=>{if(this.scrollFrame)return;this.scrollFrame=requestAnimationFrame(()=>{this.scrollFrame=0;this.sync();});};
        window.addEventListener('scroll',this.onScroll,{passive:true});
      }
      this.sync();
    }
    sync(){
      const primary=this.product.querySelector('[name=add]');
      const purchase=this.product.querySelector('.p-purchase');
      if(!primary||!purchase){this.hidden=true;return;}
      const marker=this.product.querySelector('.shc-product-shipping')||this.product.querySelector('.p-guarantee')||purchase;
      if(marker!==this.observedPurchase){
        this.intersection?.disconnect();
        this.intersection?.observe(marker);
        this.observedPurchase=marker;
      }
      const sizeField=this.product.querySelector('[data-option-name="size"]');
      const size=sizeField?.querySelector('input:checked');
      const color=this.product.querySelector('[data-option-name="color"] input:checked,[data-option-name="colour"] input:checked');
      const needsSize=Boolean(sizeField&&!size);
      const busy=Boolean(this.product.pending);
      const price=this.product.querySelector('.p-price');
      this.querySelector('[data-mobile-price]').textContent=price?.textContent.trim()||'';
      this.querySelector('[data-mobile-selection]').textContent=[color?.value,needsSize?this.dataset.choose:size?.value].filter(Boolean).join(' · ');
      this.action.disabled=busy||(!needsSize&&primary.disabled);
      this.action.textContent=busy?this.dataset.updating:!needsSize&&primary.disabled?this.dataset.soldOut:this.dataset.add;
      const error=this.querySelector('[data-mobile-error]');
      error.textContent=this.product.querySelector('.p-error')?.textContent.trim()||'';
      error.hidden=!error.textContent;
      const bounds=marker.getBoundingClientRect();
      this.hidden=!this.media.matches||bounds.bottom>0;
    }
    activate(){
      if(this.product.pending||this.action.disabled)return;
      const sizeField=this.product.querySelector('[data-option-name="size"]');
      if(sizeField&&!sizeField.querySelector('input:checked')){
        this.product.querySelector('.p-error').textContent=this.product.dataset.chooseSize;
        sizeField.scrollIntoView({block:'center',behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
        sizeField.querySelector('input')?.focus({preventScroll:true});
        return;
      }
      const primary=this.product.querySelector('[name=add]');
      if(primary&&!primary.disabled)this.product.querySelector('.shc3-product-form').requestSubmit(primary);
    }
    disconnectedCallback(){
      this.changes?.disconnect();
      this.intersection?.disconnect();
      this.media?.removeEventListener('change',this.onSync);
      window.removeEventListener('resize',this.onSync);
      window.visualViewport?.removeEventListener('resize',this.onSync);
      if(this.onScroll)window.removeEventListener('scroll',this.onScroll);
      cancelAnimationFrame(this.scrollFrame);
      this.product?.removeEventListener('change',this.onSync);
      this.action?.removeEventListener('click',this.onActivate);
      this.observedPurchase=null;
      this.ready=false;
      this.hidden=true;
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["shc3-related-tees"] && !Shopify.designMode) return;
  try {
    (() => {
  const connected = new WeakSet();
  const connect = (root = document) => {
    root.querySelectorAll('.p-gallery-recommendations').forEach((section) => {
      if (connected.has(section)) return;
      const rail = section.querySelector('.p-gallery-products');
      const previous = section.querySelector('[data-shc3-tees][data-direction="-1"]');
      const next = section.querySelector('[data-shc3-tees][data-direction="1"]');
      if (!rail || !previous || !next) return;
      connected.add(section);
      let target = null;
      let settleTimer;
      const maximum = () => Math.max(0, rail.scrollWidth - rail.clientWidth);
      const clamp = (value) => Math.min(maximum(), Math.max(0, value));
      const update = () => {
        const position = clamp(target === null ? rail.scrollLeft : target);
        previous.disabled = position <= 2;
        next.disabled = position >= maximum() - 2;
      };
      const settle = () => {
        clearTimeout(settleTimer);
        target = null;
        update();
      };
      const move = (direction) => {
        const max = maximum();
        const position = clamp(target === null ? rail.scrollLeft : target);
        if ((direction < 0 && position <= 2) || (direction > 0 && position >= max - 2)) {
          update();
          return;
        }
        const first = rail.children[0];
        const second = rail.children[1];
        const step = first && second
          ? Math.abs(second.getBoundingClientRect().left - first.getBoundingClientRect().left)
          : rail.clientWidth;
        const count = Math.max(1, Math.floor(rail.clientWidth / Math.max(1, step)));
        target = clamp(position + direction * step * count);
        update();
        clearTimeout(settleTimer);
        settleTimer = setTimeout(settle, 800);
        rail.scrollTo({
          left: target,
          behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'
        });
      };
      previous.addEventListener('click', () => move(-1));
      next.addEventListener('click', () => move(1));
      rail.addEventListener('scroll', () => {
        update();
        clearTimeout(settleTimer);
        settleTimer = setTimeout(settle, 150);
      }, { passive: true });
      rail.addEventListener('scrollend', settle);
      rail.addEventListener('pointerdown', settle, { passive: true });
      rail.addEventListener('touchstart', settle, { passive: true });
      rail.addEventListener('wheel', settle, { passive: true });
      rail.addEventListener('keydown', settle);
      const resize = new ResizeObserver(() => {
        settle();
        const position = clamp(rail.scrollLeft);
        if (Math.abs(position - rail.scrollLeft) > 2) rail.scrollTo({ left: position, behavior: 'instant' });
      });
      resize.observe(rail);
      Array.from(rail.children).forEach((card) => resize.observe(card));
      update();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => connect(), { once: true });
  else connect();
  document.addEventListener('shopify:section:load', (event) => connect(event.target));
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["shc3-sweatshirt-fit"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('shc3-sweatshirt-fit')) customElements.define('shc3-sweatshirt-fit',class extends HTMLElement{
 connectedCallback(){
  if(this.events)return;this.events=new AbortController();
  const root=this.closest('shc3-product'),dialog=this.querySelector('dialog'),result=this.querySelector('.shc1566-result'),apply=this.querySelector('[data-apply]');
  const order=['S','M','L','XL','2XL','3XL'],copy=Object.fromEntries(Array.from(this.querySelectorAll('[data-key]'),el=>[el.dataset.key,el.textContent]));
  let usual='',preference='regular',chosen='';
  const inputFor=size=>Array.from(root.querySelectorAll('[data-option-name="size"] input')).find(el=>el.value.toUpperCase().replace('XXXL','3XL').replace('XXL','2XL')===size);
  const render=()=>{
   if(!usual)return;chosen=order[order.indexOf(usual)+(preference==='oversized'?1:0)]||'';
   const input=inputFor(chosen),unavailable=input?.closest('label').querySelector('.shc3-unavailable');
   result.querySelector('[data-size]').textContent=chosen;
   result.querySelector('[data-result-copy]').textContent=chosen?copy['result_'+preference]:copy.out_of_range;
   result.querySelector('[data-stock]').textContent=!chosen?'':!input?copy.not_offered:unavailable?copy.unavailable:'';
   apply.hidden=!chosen;apply.disabled=!input||Boolean(unavailable);apply.textContent=copy.apply.replace('[size]',chosen);result.hidden=false;
  };
  root.addEventListener('click',event=>{const opener=event.target.closest('[data-shc3-fit-open]');if(opener?.getAttribute('aria-controls')===dialog.id){render();dialog.showModal();}},{signal:this.events.signal});
  dialog.addEventListener('click',event=>{
   if(event.target===dialog||event.target.closest('[data-sweat-close]'))dialog.close();
   const button=event.target.closest('button');if(!button)return;
   if(button.hasAttribute('data-suggest'))this.querySelector('[data-usual]').focus();
   if(button.dataset.usual){usual=button.dataset.usual;this.querySelectorAll('[data-usual]').forEach(el=>el.setAttribute('aria-pressed',String(el===button)));render();}
   if(button.dataset.preference){preference=button.dataset.preference;this.querySelectorAll('[data-preference]').forEach(el=>el.setAttribute('aria-pressed',String(el===button)));render();}
   if(button.hasAttribute('data-apply')&&!button.disabled){const input=inputFor(chosen);if(input){dialog.close();input.checked=true;input.dispatchEvent(new Event('change',{bubbles:true}));input.focus({preventScroll:true});}}
  },{signal:this.events.signal});
 }
 disconnectedCallback(){this.events?.abort();this.events=null;}
});
  } catch(e) { console.error(e); }
})();

})();
